@let pageId = this.pageId();
@let viewConfig = this.pageViewConfig();
@let currentLanguage = this.currentLanguage();

@if (viewConfig.theme?.background?.image; as image) {
  <app-image
    class="bg-image"
    [image]="image | imageTranslate: currentLanguage"
    alt="Background Image"
  />
}

<app-header
  class="header"
  coreActivitySection="Header"
  [pageName]="pageName() | textTranslate: 'fallback'"
  [backSwipe]="backSwipeConfig"
>
  @if (viewConfig.header && viewConfig.header.title && viewConfig.header.title.text) {
    <app-header-text slot="center" [text]="viewConfig.header.title.text | textTranslate: currentLanguage"/>
  }

  @if (!viewConfig.header || !viewConfig.header.badge ||
  (viewConfig.header && viewConfig.header.badge && viewConfig.header.badge.type === 'table-name')) {
    <app-header-badge-table-name slot="right"/>
  } @else if (viewConfig.header && viewConfig.header.badge && viewConfig.header.badge.type === 'text') {
    <app-header-badge-text slot="right" [text]="viewConfig.header.badge.text | textTranslate: currentLanguage"/>
  }
</app-header>

@if (this.menusResource.isLoading()) {
  <app-loading/>
} @else {
  @if (viewConfig.logo) {
    @let logo = viewConfig.logo | imageTranslate: currentLanguage;

    <div class="logo">
      <app-image
        class="image"
        [image]="logo"
        alt="Logo"
      />
    </div>
  }

  @if (viewConfig.title) {
    <app-text class="title">{{ viewConfig.title | textTranslate: currentLanguage }}</app-text>
  }

  @let menus = this.menusResource.value();
  @if (menus.length > 0) {
    <app-scroll>
      <div
        class="buttons"
        [class.grid]="viewConfig.layout === 'grid'"
        coreActivitySection="Categories"
      >
        @let oddNumberOfItems = menus.length % 2 !== 0;

        @for (menu of menus; track menu) {
          @let wihImage = menu.iconLocal && viewConfig.category && viewConfig.category.type === 'image-button';

          <button
            class="button"
            [class.full-width]="viewConfig.layout === 'grid' && oddNumberOfItems && $last"
            [class.with-image]="wihImage"
            [style.background-color]="
              viewConfig.category &&
              viewConfig.category.type === 'image-button' &&
              viewConfig.category.theme &&
              viewConfig.category.theme.background &&
              viewConfig.category.theme.background.color
                ? (viewConfig.category.theme.background.color | colorTranslate: currentLanguage)
                : undefined
            "
            [style.border-color]="
              viewConfig.category &&
              viewConfig.category.type === 'image-button' &&
              viewConfig.category.theme &&
              viewConfig.category.theme.border &&
              viewConfig.category.theme.border.color
                ? (viewConfig.category.theme.border.color | colorTranslate: currentLanguage)
                : undefined
            "
            [style.border-radius]="
              viewConfig.category &&
              viewConfig.category.type === 'image-button' &&
              viewConfig.category.theme &&
              viewConfig.category.theme.border &&
              viewConfig.category.theme.border.radius
                ? (viewConfig.category.theme.border.radius)
                : undefined
            "
            [coreUserActivityClickTracking]="'Open' + menu.name.split(' ').join('')"
            [routerLink]="['/', 'main', 'pdf-menu', menu.id ]"
            [queryParams]="{ ref: `page:${ pageId }` | refLinkParams }"
          >
            @if (menu.iconLocal) {
              <img
                class="icon"
                [src]="menu.iconLocal"
                [alt]="menu.name"
              />
            }

            @if (!wihImage) {
              <app-text class="label">{{ menu.name }}</app-text>
            }
          </button>
        }
      </div>
    </app-scroll>
  } @else {
    <div class="empty">
      <app-text class="message">{{ viewConfig.emptyState.message | textTranslate: currentLanguage }}</app-text>
    </div>
  }
}
